import React, { useContext } from "react";
import { observer } from "mobx-react";

import { EventContext } from "@gp/components";
import { LiveMatchTime } from "./components/match-time-info/LiveMatchTime";
import { StartTime } from "./components/match-time-info/StartTime";

export const OutrightEventDetails = observer(function OutrightEventDetails() {
	const event = useContext(EventContext);

	return (
		<>
			{event.isLive ? (
				<LiveMatchTime event={event} />
			) : (
				<StartTime event={event} className="match--special__day" />
			)}
			<div className="match--special__title">{event.name}</div>
		</>
	);
});
